import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomSelect from '../../../home/collections/CustomSelect';
import {
  customFunctionSchema,
  customFunctionSchemaValidation,
} from '../../../../common/custom/function-validation';
import { parseUtilityFunctionFormData } from '../../../../common/utils/api_utils';

import * as CustomFunction from '../../../../common/custom';
export default class EditDerivedField extends Component {
  static propTypes = {
    utility: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    updateUtility: PropTypes.func.isRequired,
    disableUpdateUtility: PropTypes.func.isRequired,
  };

  state = {
    methodTypes: Object.keys(CustomFunction)
      .filter(key => key !== 'data')
      .map(key => ({ value: key, label: key })),
    methodType: { value: this.props.utility.functionType, label: this.props.utility.functionType },
    functionName: this.props.utility.name,
  };

  componentDidMount() {
    const argsObj = {};

    this.setState(argsObj);
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  getAllAllowedFieldForSelect = dataTypes => {
    const { collection } = this.props;
    const { fields } = collection;
    if (fields.length > 0) {
      return fields
        .filter(field => dataTypes.includes(field.type))
        .map(field => ({
          value: field.fieldName,
          label: field.fieldTitle.en,
        }));
    } else {
      return [];
    }
  };

  createParmField = (params, setFieldValue, setFieldTouched, allowedTypes) => {
    console.log('params :>> ', params, this.props.utility.args);
    const utilityArg = this.props.utility.args.find(arg => {
      return arg.name === params.name;
    });

    if (params.external) {
      return (
        <div className="form-group" key={params.name}>
          <label>{params.label}*</label>
          <Field type="text" name={params.name} className="form-control form-control-sm" />
          {params.hint ? <small className="field-detail">{params.hint}</small> : ''}
        </div>
      );
    } else {
      let formatOptions = params.options
        ? params.options.map(option => ({ value: option, label: option }))
        : [];

      let fields = this.getAllAllowedFieldForSelect(allowedTypes);
      const values = { value: utilityArg.key, label: utilityArg.key };
      return (
        <div className="form-group" key={params.name}>
          <label>{params.label}*</label>
          <CustomSelect
            name={params.name}
            isMulti={params.minArgCount > 1}
            options={formatOptions.length > 0 ? formatOptions : fields}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            onChangeValue={this.handleChange}
          />
          {params.hint ? <small className="field-detail">{params.hint}</small> : ''}
          <ErrorMessage name={params.name}>
            {msg => <p className="pl-0 ml-5 text-error">{msg}</p>}
          </ErrorMessage>
        </div>
      );
    }
  };

  renderParameters = (setFieldValue, setFieldTouched) => {
    const { methodType } = this.state;
    const paramField = [];
    if (methodType) {
      const functionData = CustomFunction.data.find(param => {
        return param.name === methodType.value;
      });

      console.log('functionData :>> ', functionData);

      functionData.args.forEach(param => {
        paramField.push(
          this.createParmField(param, setFieldValue, setFieldTouched, functionData.allowedTypes),
        );
      });
    }
    return paramField;
  };

  handleSubmit = (values, setSubmitting, resetForm) => {
    const createUtilityData = parseUtilityFunctionFormData(values);
    const { utility, projectId, collection, updateUtility } = this.props;
    const finalObject = {
      utilityUuid: utility.uuid,
      projectId,
      collectionUuid: collection.uuid,
      data: createUtilityData,
    };
    setSubmitting(false);
    resetForm();
    updateUtility(finalObject);
  };

  generateUtilityFormSchema = () => {
    const { utility } = this.props;

    const schema = {
      functionName: utility.name,
      methodType: utility.functionType,
      formatType: '',
      length: '',
      numbers: '',
      numbers1: '',
      numbers2: '',
      subject: '',
      endopt: '',
      noSplitopt: '',
      datentime: '',
    };
    utility.args.map(arg => {
      schema[arg.name] = arg.key;
    });
    console.log('schema :>> ', schema);
    return schema;
  };

  render() {
    const { disableUpdateUtility } = this.props;
    return (
      <div className="col-12">
        <Formik
          initialValues={this.generateUtilityFormSchema}
          validationSchema={customFunctionSchemaValidation}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values, setSubmitting, resetForm);
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
            return (
              <Form>
                <div className="form-group">
                  <label>Name*</label>
                  <Field
                    type="text"
                    name="functionName"
                    value={this.state.functionName}
                    className="form-control form-control-sm"
                    placeholder="Name of Method"
                  />
                  <small className="field-detail">Name to Be Appear on UI</small>
                  <ErrorMessage name="functionName">
                    {msg => <p className="pl-0 ml-5 text-error">{msg}</p>}
                  </ErrorMessage>
                </div>
                <div className="form-group">
                  <label>Type*</label>
                  <CustomSelect
                    name="methodType"
                    isMulti={false}
                    value={this.state.methodType}
                    options={this.state.methodTypes}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    onChangeValue={this.handleChange}
                  />
                  <small className="field-detail">
                    Functionality to be bind with above derived field
                  </small>
                  <ErrorMessage name="methodType">
                    {msg => <p className="pl-0 ml-5 text-error">{msg}</p>}
                  </ErrorMessage>
                </div>
                {this.renderParameters(setFieldValue, setFieldTouched)}

                <div className="row">
                  <div className="col-8"></div>
                  <div className="col-4">
                    <button type="submit" className="btn btn-theme-submit btn-sm">
                      <i className="wb webconnect-save-regular"></i> Update
                    </button>
                    &nbsp;&nbsp;
                    <button className="btn btn-sm btn-theme-cancel" onClick={disableUpdateUtility}>
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  }
}
